import { render, staticRenderFns } from "./Demand.vue?vue&type=template&id=39a3dc95&"
import script from "./Demand.vue?vue&type=script&lang=js&"
export * from "./Demand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39a3dc95')) {
      api.createRecord('39a3dc95', component.options)
    } else {
      api.reload('39a3dc95', component.options)
    }
    module.hot.accept("./Demand.vue?vue&type=template&id=39a3dc95&", function () {
      api.rerender('39a3dc95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/DataView/Study/Demand.vue"
export default component.exports